import { basicEnum } from "./base";

export const AssociateRegistrationStatusEnum = basicEnum([
    {
        label: "MENUNGGU",
        value: "W",
    },
    {
        label: "DITERIMA",
        value: "A",
    },
    {
        label: "DITOLAK",
        value: "R",
    },
]);

export namespace AssociateRegistrationStatusEnum {
    export type Labels = (typeof AssociateRegistrationStatusEnum)["labels"][number];
    export type Values = (typeof AssociateRegistrationStatusEnum)["values"][number];
}
